import React, { useState } from 'react'
import { Box, SimpleGrid, Text } from '@chakra-ui/react'
import { StyledNumberInput } from '~editor/components/StyledNumberInput'
import useDispatch from '~editor/hooks/useDispatch'
import { useSelector } from '~editor/hooks/useSelector'
import { getSelectedNode } from '~editor/selectors/nodes'
import { ActionGestureTypes } from '~core/forge.type'
import { Button } from '@chakra-ui/react'
import { actionsMetasDefaults } from '~editor/utils/constants'

interface DelayInputProps {
  valueInMs: number
  onChange: (value: number) => void
}

export const DelayInput = ({ valueInMs, onChange }: DelayInputProps) => {
  const [useSeconds, setUseSeconds] = useState(false)

  return (
    <Box display="flex" flexWrap="nowrap">
      <StyledNumberInput
        step={useSeconds ? 0.01 : 1}
        marginRight="5px"
        value={useSeconds ? valueInMs / 1000 : valueInMs}
        onChange={(stringValue) => {
          const value = Number(
            (
              (useSeconds ? parseFloat : parseInt)(stringValue) *
              (useSeconds ? 1000 : 1)
            ).toFixed(2),
          )

          onChange(value)
        }}
      />
      <Button
        variant="ghost"
        isActive={!useSeconds}
        onClick={() => setUseSeconds(false)}
      >
        {'MS'}
      </Button>
      <Button
        variant="ghost"
        isActive={useSeconds}
        onClick={() => setUseSeconds(true)}
      >
        {'S'}
      </Button>
    </Box>
  )
}

interface MouseWheelInputProps {
  value: number
  onChange: (value: number) => void
}

export const MouseWheelInput = ({ value, onChange }: MouseWheelInputProps) => {
  const [isUp, setIsUp] = useState(value >= 0)

  return (
    <Box display="flex" flexWrap="nowrap" alignItems="center">
      <StyledNumberInput
        step={1}
        min={1}
        max={99}
        marginRight="5px"
        value={Math.abs(value)}
        onChange={(stringValue) => {
          const value = parseInt(stringValue) * (isUp ? 1 : -1)

          onChange(value)
        }}
      />
      <Text color="ui.text.grey" fontWeight="700" marginRight="5px">
        {'Clicks'}
      </Text>
      <Button
        variant="ghost"
        isActive={isUp}
        onClick={() => {
          setIsUp(true)
          onChange(Math.abs(value))
        }}
      >
        {'UP'}
      </Button>
      <Button
        variant="ghost"
        isActive={!isUp}
        onClick={() => {
          setIsUp(false)
          onChange(-Math.abs(value))
        }}
      >
        {'DOWN'}
      </Button>
    </Box>
  )
}

interface OnHoldDelayInputProps {
  activeActionGesture: ActionGestureTypes
}

export const OnHoldDelayInput = ({
  activeActionGesture,
}: OnHoldDelayInputProps) => {
  const dispatch = useDispatch()
  const OnHoldMs = useSelector((state) => {
    const node = getSelectedNode(state)

    return node?.actionsMetas?.OnHold?.ms ?? actionsMetasDefaults?.OnHold?.ms
  })

  return (
    <SimpleGrid
      padding="10px"
      borderRadius="5px"
      templateRows={'repeat(1)'}
      templateColumns="120px 1fr auto"
      gap="5px"
      alignItems="center"
      justifyContent="flex-start"
      marginTop="10px"
      marginBottom="0px"
      fontSize="12px"
      height="42px"
    >
      <Text fontWeight="700">{'Hold for:'}</Text>

      <DelayInput
        valueInMs={OnHoldMs}
        onChange={(value) => {
          dispatch.nodes.updateNodeProperty({
            property: 'actionsMetas.OnHold.ms',
            value,
          })
        }}
      />
    </SimpleGrid>
  )
}
